/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes JS from the /components dirctory
import autoTemplateComponent from './core/auto-template-component'
autoTemplateComponent()

import './components/campaignFeed'

/*
|--------------------------------------------------------------------------
| App
|
| All application related code goes here
| App code is automatically uses Babel and runs minification when the production command is used
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// window.$ = window.jQuery = jQuery
// const isIE11 = !!window.MSInputMethodContext && !!document.documentMode

import loadSprite from './components/loadSprite.js'
loadSprite()

/*
|--------------------------------------------------------------------------
| Header & Nav
|--------------------------------------------------------------------------
*/

import { megaMenu } from './components/header/header.js'
import detectNavOverflow from './components/detectNavOverflow.js'
megaMenu()
detectNavOverflow()
/*
|--------------------------------------------------------------------------
| Alert Banners
|--------------------------------------------------------------------------
*/

import initAlertBanners from './components/alertBanners.js'
initAlertBanners()

/*
|--------------------------------------------------------------------------
| Global Search Modal
|--------------------------------------------------------------------------
*/

import initGlobalSearch from './components/globalSearch.js'
initGlobalSearch()

import autocomplete from './components/autocomplete'
autocomplete()

/*
|--------------------------------------------------------------------------
| Archive Filters
|--------------------------------------------------------------------------
*/

import(
  /* webpackChunkName: "filters" */ './components/listings-grid/filters'
).then((module) => {
  module.toggleFilters()
})

/*
|--------------------------------------------------------------------------
| Hero Quick-Search Bar
|--------------------------------------------------------------------------
*/
import initHeroSearch from './components/heroSearch.js'
initHeroSearch()

/*
|--------------------------------------------------------------------------
| Search Results
|--------------------------------------------------------------------------
*/
if (document.getElementById('js-search-results-hits')) {
  import(
    /* webpackChunkName: "search-results" */ './components/search-results/results'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| Modals
|--------------------------------------------------------------------------
*/
if (document.getElementsByClassName('js-modal').length) {
  import(/* webpackChunkName: "modals" */ './components/modals').then(
    (module) => {
      module.default()
    },
  )
}

/*
|--------------------------------------------------------------------------
| Count Up Javascript
|--------------------------------------------------------------------------
*/
if (document.getElementsByClassName('js-count-up').length) {
  import(/* webpackChunkName: "count-up" */ './components/countUp.js').then(
    (module) => {
      module.default()
    },
  )
}

/*
|--------------------------------------------------------------------------
| Count Down Javascript
|--------------------------------------------------------------------------
*/
if (document.getElementsByClassName('js-count-down').length) {
  import(/* webpackChunkName: "count-down" */ './components/timer.js').then(
    (module) => {
      module.default()
    },
  )
}

/*
|--------------------------------------------------------------------------
| Flexible Content Components
|--------------------------------------------------------------------------
*/

// Accordion component
if (document.getElementsByClassName('js-accordion__header').length) {
  import(/* webpackChunkName: "accordion" */ './components/accordion').then(
    (module) => {
      module.default()
    },
  )
}

// Tabbed content component
if (document.getElementsByClassName('c-tabbed-content').length) {
  import(/* webpackChunkName: "tabbed-content" */ './components/tabbedContent')
}

// Feature slider component
if (document.getElementsByClassName('c-feature-slider').length) {
  import(
    /* webpackChunkName: "feature-slider" */ './components/featureSlider'
  ).then((module) => {
    module.default()
  })
}

// Image gallery component
if (document.getElementsByClassName('js-image-gallery').length) {
  import(
    /* webpackChunkName: "image-gallery" */ './components/imageGallery'
  ).then((module) => {
    module.default()
  })
}

// Utility carousel component
if (document.getElementsByClassName('c-utility-carousel').length) {
  import(
    /* webpackChunkName: "utility-carousel" */ './components/utilityCarousel'
  ).then((module) => {
    module.default()
  })
}

// Anchored content component
if (document.getElementsByClassName('js-anchored-content').length) {
  import(
    /* webpackChunkName: "image-gallery" */ './components/anchoredContent'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| Parallax Video Hero
|--------------------------------------------------------------------------
*/

if (document.getElementsByClassName('js-parallax-video').length) {
  import(
    /* webpackChunkName: "hero-video-parallax" */ './components/advanced-home-hero/heroVideoParallax'
  ).then((module) => {
    module.default()
  })

  import(
    /* webpackChunkName: "hero-video-ui" */ './components/advanced-home-hero/heroVideoUi'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| Generic Hero Video
|--------------------------------------------------------------------------
*/

if (document.getElementById('js-hero-video-controls')) {
  import(
    /* webpackChunkName: "hero-video-controls" */ './components/hero/videoControls'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| oEmbed video player (youtube, vimeo)
|--------------------------------------------------------------------------
*/

if (document.querySelector('.js-oembed-player')) {
  import(/* webpackChunkName: "oembed-video" */ './components/oembedVideo')
}

/*
|--------------------------------------------------------------------------
| Animated icons
|--------------------------------------------------------------------------
*/

if (document.getElementsByClassName('o-animated-ring').length) {
  import(
    /* webpackChunkName: "animated-icons" */ './components/animatedIcons'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| Animated Map Shortcode
|--------------------------------------------------------------------------
*/
if (document.getElementById('js-animated-map')) {
  import(
    /* webpackChunkName: "animated-map" */ './components/shortcodes/animatedMap'
  ).then((module) => {
    module.default()
  })
}

/*
|--------------------------------------------------------------------------
| Contribution Map Shortcode
|--------------------------------------------------------------------------
*/
if (document.getElementById('js-contribution-map')) {
  import(
    /* webpackChunkName: "contribution-map" */ './components/shortcodes/contributionMap'
  ).then((module) => {
    module.initContributionMap()
  })
}

/*
|--------------------------------------------------------------------------
| Back to top
|--------------------------------------------------------------------------
*/
if (document.querySelector('.c-hero')) {
  import(/* webpackChunkName: "back-to-top" */ './components/backToTop').then(
    (module) => {
      module.default()
    },
  )
}

/*
|--------------------------------------------------------------------------
| Third-Party
|
| Libaries, external modules etc
|
| glightbox - https://github.com/biati-digital/glightbox
|--------------------------------------------------------------------------
*/

import 'objectFitPolyfill'
window.objectFitPolyfill()

// Global generic glightbox elements
if (document.getElementsByClassName('glightbox').length) {
  import(/* webpackChunkName: "lightbox" */ './components/lightbox').then(
    (module) => {
      module.default()
    },
  )
}

// Global generic keen slider elements
if (document.getElementsByClassName('js-keen-slider').length) {
  import(/* webpackChunkName: "keen-slider" */ './components/keenSlider').then(
    (module) => {
      module.initKeenSliders()
    },
  )
}

// Plyr JS video elements - for both <video> and <iframe> elements
if (
  document.getElementsByClassName('js-video-player').length ||
  document.getElementsByClassName('js-iframe-video-player').length
) {
  import(/* webpackChunkName: "plyr-js" */ './components/plyrJs.js').then(
    (module) => {
      module.initPlyrJs()
      module.initIframePlyrJs()
    },
  )
}

import toggle from './components/toggle'
window.toggle = toggle
